import BaseObject from '../../base/base_object';
import NativeIOS from './native/native_ios';
import NativeAndroid from './native/native_android';
import NativeIOSPoker from './native/native_ios_poker';
import Device from '../../utils/device/device';
import NativeIOSSport from './native/native_ios_sport';



/**
 *
 *
 */
class HybridFactory extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'HybridFactory';


    getHybridWrapper() {
        if (!Device.hybrid.isHybrid) {
            return null;
        }
        if (Device.os.isAndroid) {
            this.logger.info('Create Native Android');
            return NativeAndroid.create();
        }
        if (Device.os.isIOS) {
            if (Device.hybrid.inPoker) {
                this.logger.info('Create Native IOS For Poker');
                return NativeIOSPoker.create();
            } else if (Device.hybrid.inSport) {
                this.logger.info('Create Native IOS For Sport');
                return NativeIOSSport.create();
            } else {
                this.logger.info('Create Native IOS');
                return NativeIOS.create();
            }
        }
        return null;
    }
}
export default HybridFactory;